// import React from 'react'

// function Orders() {
//   return (
//     <div>Orders</div>
//   )
// }

// export default Orders


import React, { useEffect } from 'react'
import AddHeader from '../components/AddHeader/AddHeader'
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import FilterContainer from '../components/FilterContainer/FilterContainer';
import CustomTable from '../components/CustomTable/CustomTable';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import { fetchProducts } from '../hooks/Products';
import { fetchOrders } from '../hooks/Orders';
// import { fetchProducts } from '../hooks/products';
import VisibilityIcon from '@mui/icons-material/Visibility'
import InvoiceContainer from '../components/InvoiceContainer/InvoiceContainer';

function Orders() {
    const navigate = useNavigate();
    const dispatch=useDispatch()
  const { currentLocal } = useSelector((state) => state.currentLocal);
        const {list:orders } = useSelector((state) => state.orders);
        console.log(orders);
        
    useEffect(() => {
          dispatch(fetchProducts());
    
    }, [dispatch])
  
  const header = [
    { id: "id", numeric: false, disablePadding: true, label: currentLocal.home.ID },
        { id: "trackingNumber", numeric: true, disablePadding: false, label:currentLocal.home.trackingNumber},
    { id: "date", numeric: true, disablePadding: false, label:  currentLocal.home.date},
    { id: "Totalamount", numeric: true, disablePadding: false, label: currentLocal.home.Totalamount},
      { id: "orderStatus", numeric: true, disablePadding: false, label: currentLocal.home.orderStatus},

    { id: "actions", numeric: true, disablePadding: false, label: currentLocal.home.actions },

  ];
  
const myData = orders?.map((item) => {
  console.log(item);
  
  return {
    id: item?.id,
    trackingNumber:item?.order_no?item?.order_no:item?.id||"------",
    date:item?.created_at?.slice(0,10)||"------",
    Totalamount:item?.total+currentLocal.home.egp||"------",
    orderStatus:item.status?.id==3?"proccing":item?.status?.id==4?"shipped":item?.status?.id==5?"Delivered":"Pending"||"------",
    actions: (
      <div className='d-flex align-items-center'>
        <div 
          className='d-flex align-items-center' 
          style={{ cursor: "pointer" }} 
          onClick={() => navigate(`/dashboard/order/${item?.id}`)}
        >
          <VisibilityIcon
            sx={{ 
              color: '#6C757D', 
              fontSize: '1rem', 
              marginLeft: '5px',
              marginRight: '5px' // أضف مسافة بسيطة من الجهة الأخرى أيضاً
            }}
          />
          <p className='mb-0' style={{ fontSize: '1rem', color: '#6C757D' }}>
            {currentLocal.home.Preview}
          </p>
        </div>
        <div>
                <InvoiceContainer
            trackingNumber={item?.order_no}
            createdAt={item && item?.created_at && item?.created_at.substring(0, 10)}
            total={item?.total}
            paymentMethod={item?.payment_method}
            address1={item?.address?.notes}
            subtotal={item?.subtotal}
            name={item?.client?.name}
            address2={
              item?.address
                ? `${item?.address.house_number || ""}, ${item?.address.block || ""}, ${item?.address.street || ""}`
                : ""
            }
            phone={item?.client?.phone}
            city={item?.address?.city?.name}
            region={item?.address?.region}
            street={item?.address?.street}
            block={item?.address?.block}
            house_number={item?.address?.house_number}
            items={item?.details}
            shippingAmount={item?.delivery_fee}

          />
        </div>
      </div>
    )
  };
});
  return (
    <div className='outlit_bg px-4'>
      <AddHeader
        title={currentLocal.home.orders}
        text={""}
      />
      <FilterContainer
        exportexcel={false}
        searchState={false}
      />
{orders?.length>0&&
      <div className='mx-4'>
        <CustomTable
          headCells={header}
          rows={myData} />
      </div>
}
    </div>
  )
}

export default Orders
